/* globals jQuery, moment */

const $ = jQuery;

import View from './base';

const INPUT_FORMAT = 'YYYY-MM-DD';

const MONTHS = [ 'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December' ];
const DAYS = [ 'S', 'M', 'T', 'W', 'T', 'F', 'S' ];

const dayNamesRow = ( function() {
	var cells = '';

	for ( let i = 0; i < DAYS.length; i++ ) {
		cells += `<th class="calendar-dayname">${DAYS[i]}</th>`;
	}

	return `<tr class="calendar-daynames">${cells}</tr>`;
} )();

export default View.extend( {
	events: {
		'click .-date': 'saveDate',
		'input .-input': 'loadDate',
	},

	elements: {
		$input: '.-input',
	},

	initialize: function() {
		View.prototype.initialize.apply( this, arguments );

		this.date = moment();
	},

	saveDate: function( e ) {
		var date = $( e.currentTarget ).data( 'date' );

		this.date = moment( date, INPUT_FORMAT );
		this.$input.val( this.date.format( INPUT_FORMAT ) );
		this.renderDate();

		this.trigger( 'update' );
	},

	loadDate: function( e ) {
		this.date = moment( e.currentTarget.value, INPUT_FORMAT );
		this.renderDate();
	},

	render: function() {
		var now = this.date.toDate();

		var year = now.getFullYear(),
			month = now.getMonth();

		for ( let i = 0; i < 12; i++ ) {
			let date = new Date( year, month + i, 1 );
			this.renderMonth( date.getFullYear(), date.getMonth() );
		}

		this.renderDate();

		this.$( `.-date[data-date="${moment().format('YYYY-M-D')}"]` ).addClass( 'today' );

		return this;
	},

	renderMonth: function( year, month ) {
		var startDay = new Date( year, month, 1 ).getDay(),
			lastDay = 32 - ( new Date( year, month, 32 ).getDate() );

		var $table = $( `<table class="calendar" id="month-${month}"></table>` );

		$table.html( `
			<caption class="calendar-title">${MONTHS[month]} ${year}</caption>
			<thead class="calendar-header">
				${dayNamesRow}
			</thead>
		` );

		var $body = $( '<tbody class="calendar-weeks"></tbody>' );

		var $row = $( '<tr class="calendar-week"></tr>' );

		if ( startDay ) {
			for ( let prev = 0; prev < startDay; prev++ ) {
				$row.append( `<td class="calendar-day-prev">&nbsp;</td>` );
			}
		}

		var dayOfWeek = startDay;
		for ( let day = 1; day <= lastDay; day++ ) {
			$row.append( `<td class="calendar-day -date" data-date="${year}-${month + 1}-${day}">
				<span class="calendar-day-number">${day}</span>
			</td>` );
			dayOfWeek++;
			if ( dayOfWeek > 6 ) {
				$body.append( $row );
				$row = $( '<tr class="calendar-week"></tr>' );
				dayOfWeek = 0;
			}
		}

		if ( dayOfWeek ) {
			for ( let next = dayOfWeek; next < 7; next++ ) {
				$row.append( `<td class="calendar-day-next">&nbsp;</td>` );
			}
		}

		$body.append( $row );

		this.$el.append( $table.append( $body ) );
	},

	renderDate: function() {
		this.$( '.-date' ).removeClass( 'active' );
		this.$( `.-date[data-date="${this.date.format('YYYY-M-D')}"]` ).addClass( 'active' );
	},
} );
